import { instance, DateService } from 'seismic-common';
import { toLocalDate, isMobileDevice, getDefaultContentByQueryString, isExpiredByBetweenDays } from '../commonUtil/util';
import { ANONYMOUS_PATTERN, DOWNLOAD_MODE } from '../commonUtil/constants';
import { getGDPRCookie } from '../commonUtil/cookieUtil';
import { getGlobalGDPRDetail } from '../commonUtil/gdprUtil';
import { isValidColor } from '../commonUtil/isValidColor';

const handleWhiteHighlightColor = (highlightColor) => {
    if (highlightColor.toUpperCase() === '#FFF' || highlightColor.toUpperCase() === '#FFFFFF' || highlightColor.toUpperCase() === 'WHITE') {
        return '#293F4D';
    }

    return highlightColor;
};

const handleIsShowNewChip = (isNewContent, createdDate, isExpired) => {
    if (!isExpired && isNewContent && createdDate && !isExpiredByBetweenDays(createdDate)) {
        return true;
    }

    if (!isExpired && isNewContent && !createdDate) {
        return true;
    }

    return false;
};

const buildGlobalGDPRSetting = (privacySetting = {}, isExpired) => {
    if (!privacySetting) {
        return {
            isNoDisclaimer: true,
            isShowPrivacySettingBtn: false,
            disclaimerMessage: '',
            privacyLink: null,
            isShowDisclaimerMsg: false,
            isEnableGlobalGDPR: false,
            useDefaultMessage: false,
            isShowRejectAllBtn: false
        };
    }

    const { isShowDisclaimerMessage, isShowPrivacySettingBtn, isNoDisclaimer, disclaimerMessage, isShowRejectAllBtn } = getGlobalGDPRDetail(privacySetting);
    const showDisclaimerMsg = isShowDisclaimerMessage && !getGDPRCookie() && !isExpired;

    return {
        isNoDisclaimer,
        isShowPrivacySettingBtn,
        disclaimerMessage,
        privacyLink: privacySetting.policyUrls || [],
        isShowDisclaimerMsg: showDisclaimerMsg,
        isEnableGlobalGDPR: privacySetting.isEnable,
        useDefaultMessage: false,
        isShowRejectAllBtn
    };
};

export const buildLinkInfoModel = (response) => {
    const { viewerSettings, link, privacySetting, enableLiveSendDownloadOptions } = response;
    const { isPasswordRequired, isExpired, isCompliancePasswordRequired, brandingSetting, browserSetting, isAllowSharingLink } = viewerSettings;
    const { sentAt, canDownload, interactionId, downloadFormats } = link;

    const defaultHighlightColor = '#F1592A';
    const highlight = brandingSetting ? handleWhiteHighlightColor(brandingSetting.highlightColor) : defaultHighlightColor;
    const brandingHilightColor = isValidColor(highlight) ? highlight : defaultHighlightColor;
    const viewerSetting = {
        logo: brandingSetting ? brandingSetting.logo : '',
        browserTitle: browserSetting ? browserSetting.title : 'Seismic LiveSend',
        browserFavicon: browserSetting ? browserSetting.favicon : '',
        brandingHilightColor
    };

    let gdprSettingData = {};
    gdprSettingData = buildGlobalGDPRSetting(privacySetting, isExpired);

    const dateService = instance.getService(DateService);
    const linkBasicInfo = {
        sentAt: dateService.formatDate(toLocalDate(sentAt)),
        isPasswordRequired,
        isExpired,
        isCompliancePasswordRequired,
        canDownload,
        isAllowSharingLink,
        interactionId,
        enableLiveSendDownloadOptions,
        downloadFormats: enableLiveSendDownloadOptions ? downloadFormats : DOWNLOAD_MODE.OriginalFormat
    };

    let contents = [];
    let contentCovers = [];
    let selectedContent = {};
    let fromInitialDoc = false;
    if (link.contents.length > 0) {
        const defaultContent = link.contents[0];
        const { selectedItem, initialDoc } = getDefaultContentByQueryString(link.contents, defaultContent);
        if (initialDoc) {
            selectedContent = selectedItem;
            fromInitialDoc = initialDoc;
        } else if (!initialDoc && (link.contents.length === 1 || !isMobileDevice.any())) {
            selectedContent = selectedItem;
        }

        contents = link.contents.map(c =>
            ({
                id: c.id,
                cover: '',
                format: c.format,
                name: c.name,
                versionId: c.sourceContentVersionId,
                isShowNewChip: handleIsShowNewChip(c.isNewContent, c.createdDate, isExpired)
            })
        );
        contentCovers = link.contents.map(c =>
            ({
                id: c.id,
                cover: ''
            })
        );
    }

    const sender = {
        id: link.sender.id,
        name: '',
        email: '',
        avatar: '',
        isAnonymousSender: !!ANONYMOUS_PATTERN.test(link.sender.name)
    };

    return {
        viewerSetting,
        gdprSetting: gdprSettingData,
        linkBasicInfo,
        contents,
        contentCovers,
        selectedContent,
        sender,
        fromInitialDoc
    };
};
